<!--
    Created by 程雨喵'mac on 2023/12/28.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：
    功能概述：
-->
<style lang="less">
.service-dealer-setting-dialog {
  padding-bottom: @containerGap;
  height: 100%;
  .setting-inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    .setting-inner-header {
      display: flex;
      flex-wrap: wrap;
      font-size: 13px;
      box-sizing: border-box;
      line-height: 17px;
      background: @backColorNormal;
      border-radius: @borderRadiusMid;
      .setting-inner-header-row {
        .flex-grow(50%);
        &:nth-of-type(n+3) {
          padding-top: @containerGap * 0.5;
        }
      }
    }
    .setting-inner-box {
      flex: 1;
      margin-top: @containerGap;
      //background: @backColorStrong;
      overflow: auto;
      .step-outer {
        padding-top: @containerGap;
        background-color: @backColorStrong;
        border-radius: @borderRadiusMin @borderRadiusMin 0 0;
      }
    }
    .setting-content-box {
      background-color: @backColorStrong;
      border-radius: 0 0 @borderRadiusMin @borderRadiusMin;
    }
  }
}
</style>

<template>
  <yg-modal
    width="600"
    :title="modalTitle"
    :back-type="2"
    :sure-text="sureText"
    :sure-button-disabled="buttonDisabled"
    :sure-button-disabled-text="buttonDisabledMsg"
    @on-sure="onSure"
    @on-close="onClose"
  >
    <div
      slot="content"
      class="service-dealer-setting-dialog"
    >
      <div class="setting-inner">
        <div class="setting-inner-header">
          <div
            v-for="(item, i) in topInfos"
            :key="i"
            class="setting-inner-header-row"
          >
            <yg-attribute-key-value
              :label="item.label"
              :label-width="120"
              :max-height="18 * 3"
              :value="model[item.key]"
              :can-copy="item.canCopy"
              :can-tooltip="!!item.canTooltip"
            />
          </div>
        </div>
        <div class="setting-inner-box">
          <div
            v-if="isStepMod"
            class="step-outer"
          >
            <yg-steps
              :current-index="tab.index"
              :items="tab.dicItems"
              prev-text=""
              next-text=""
              @on-click="onStepChanged"
            />
          </div>
          <yg-tab-primary
            v-else
            :index="tab.index"
            :permission-items="tab.permissionItems"
            :items="tab.items"
            :type="2"
            @on-change="onTabChanged"
          />
          <div class="padding-primary setting-content-box">
            <v-account
              v-if="tab.index === 0"
              :model="model"
              @on-change="onChangeDisabled"
            />
            <v-contact
              v-else-if="tab.index === 1"
              :model="model"
              @on-change="onChangeDisabled"
            />
            <v-settle-account
              v-else-if="tab.index === 2"
              :model="model"
              @on-change="onChangeDisabled"
            />
            <v-ratio-config
              v-else-if="tab.index === 3"
              :model="model"
              @on-change="onChangeDisabled"
            />
          </div>
        </div>
      </div>
    </div>
  </yg-modal>
</template>

<script>
import PcApiSet from '@/request/api/PcApiSet';
import vAccount from '@/pages/020__organizationManager/_components/account.vue';
import vContact from '@/pages/020__organizationManager/_components/contact.vue';
import vSettleAccount from './settleAccount.vue';
import vRatioConfig from './ratioConfig.vue';
import stepMixin from '@/pages/020__organizationManager/_mixin/stepMixin';
export default {
  components: { vAccount, vContact, vSettleAccount, vRatioConfig },
  mixins: [stepMixin],
  props: {
    index: {
      type: Number,
      default: 0
    },
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      topInfos: [
        { label: '物业公司名称：', key: 'propertyCompanyName', canCopy: false, canTooltip: true },
        { label: '物业公司主体类型：', key: 'principalTypeName', canCopy: false, canTooltip: true },
        { label: '物业公司编码：', key: 'propertyCompanyId', canCopy: false, canTooltip: true },
        { label: '所属服务商：', key: 'serviceProviderName', canCopy: false, canTooltip: true }
      ],
      tab: {
        index: 0,
        items: ['登录账号设置', '联系人设置', '结算账户设置', '费率配置'],
        permissionItems: [
          'system:propertyCompany:admin:set', 'system:propertyCompany:contact:set', 'system:propertyCompany:ratioConfig:set', 'system:propertyCompany:settleAccount:set'
        ],
        dicItems: [
          { title: '步骤1', info: '登录账号设置' },
          { title: '步骤2', info: '联系人设置' },
          { title: '步骤3', info: '结算账户设置' },
          { title: '步骤4', info: '费率配置' }
        ]
      },
      buttonDisabled: true,
      buttonDisabledMsg: '',
      needRefreshList: false
    };
  },
  created () {
    this.tab.index = this.index;
  },
  methods: {
    onSure () {
      console.log(this.model);
      let res = {};
      const tIndex = this.tab.index;
      if (tIndex === 0) {
        // 登录账号设置
        res = this.model.checkValidAccountSubmit();
      } else if (tIndex === 1) {
        // 联系人设置
        res = this.model.checkValidConcatSubmit();
      } else if (tIndex === 2) {
        // 结算账户
        res = this.model.settleAccount.checkValidSettleAccountSubmit();
      } else if (tIndex === 3) {
        // 费率配置
        res = this.model.ratioConfig.checkValidRatioConfigSubmit();
      }
      if (!res.success) {
        this.$Message.warning(res.msg);
      } else {
        this.requestSubmit(tIndex, res.params);
      }
    },
    onClose () {
      this.$emit('on-close', this.needRefreshList);
    },
    onChangeDisabled ({ disabled, msg }) {
      this.buttonDisabled = disabled;
      this.buttonDisabledMsg = msg;
    },
    onTabChanged (e) {
      if (e === this.tab.index) return;
      this.buttonDisabled = false;
      this.buttonDisabledMsg = '';
      this.tab.index = e;
    },
    requestSubmit (type, params) {
      let api = {};
      if (type === 0) {
        // 登录账号
        api = PcApiSet.pcAdminSet;
      } else if (type === 1) {
        // 联系人
        api = PcApiSet.pcConcatSet;
      } else if (type === 2) {
        // 结算账户
        api = PcApiSet.pcSettleAccountSet;
      } else if (type === 3) {
        // 费率配置
        api = PcApiSet.pcRatioConfigSet;
      }
      api.params = params;
      this.$http(api).then(res => {
        this.needRefreshList = type === 0 || type === 1;
        if (type === 0) {
          // 提交后就不可编辑了
          this.model.h5AdminCanChange = false;
        } else if (type === 0) {
          this.model.code = '';
        }
        this.onChangeDisabled({ disabled: true, msg: '无数据变更' });
        this.$Message.success('操作成功');
        this.submitFinish();
      });
    }
  }
};
</script>
